/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KinnserLookupOption } from './KinnserLookupOption';
import {
    KinnserLookupOptionFromJSON,
    KinnserLookupOptionFromJSONTyped,
    KinnserLookupOptionToJSON,
    KinnserLookupOptionToJSONTyped,
} from './KinnserLookupOption';

/**
 * 
 * @export
 * @interface KinnserLookups
 */
export interface KinnserLookups {
    /**
     * 
     */
    clinic_key: string;
    /**
     * 
     */
    corporation_key: string;
    /**
     * 
     */
    fetched_at: string;
    /**
     * 
     */
    fields: { [key: string]: Array<KinnserLookupOption>; };
}

/**
 * Check if a given object implements the KinnserLookups interface.
 */
export function instanceOfKinnserLookups(value: object): value is KinnserLookups {
    if (!('clinic_key' in value) || value['clinic_key'] === undefined) return false;
    if (!('corporation_key' in value) || value['corporation_key'] === undefined) return false;
    if (!('fetched_at' in value) || value['fetched_at'] === undefined) return false;
    if (!('fields' in value) || value['fields'] === undefined) return false;
    return true;
}

export function KinnserLookupsFromJSON(json: any): KinnserLookups {
    return KinnserLookupsFromJSONTyped(json, false);
}

export function KinnserLookupsFromJSONTyped(json: any, ignoreDiscriminator: boolean): KinnserLookups {
    if (json == null) {
        return json;
    }
    return {
        
        'clinic_key': json['clinic_key'],
        'corporation_key': json['corporation_key'],
        'fetched_at': json['fetched_at'],
        'fields': json['fields'],
    };
}

export function KinnserLookupsToJSON(json: any): KinnserLookups {
    return KinnserLookupsToJSONTyped(json, false);
}

export function KinnserLookupsToJSONTyped(value?: KinnserLookups | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clinic_key': value['clinic_key'],
        'corporation_key': value['corporation_key'],
        'fetched_at': value['fetched_at'],
        'fields': value['fields'],
    };
}

